import { IValidationRule } from "@/types"

const textBuildingBlockValidationRules: { [s: string]: IValidationRule } = {
    textBlockId: {
        required: true,
    },
    text: {
        required: true,
    }
}

export default textBuildingBlockValidationRules
